import { render } from "./ResetPasswordComponent.vue?vue&type=template&id=43be7920&scoped=true&ts=true"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=ts"

import "./ResetPasswordComponent.vue?vue&type=style&index=0&id=43be7920&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43be7920"]])

export default __exports__